import {Component, OnInit, OnDestroy} from '@angular/core';
import {User} from '../../../../../models/user';
import {BusinessDataService} from '../../../../../data-repositories/business-data.service';
import {Subscription} from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-personal-second-holder',
  templateUrl: './personal-second-holder.component.html',
  styleUrls: ['./personal-second-holder.component.scss']
})
export class PersonalSecondHolderComponent implements OnInit, OnDestroy {
  user: User;
  private subscription = new Subscription();

  constructor(
    private service: BusinessDataService) {

    this.subscription.add(this.service.GetUser().subscribe(s => {
      this.user = s.model;
    }));
  }

  ngOnInit() {
  }

  public updateUser(): void {
    this.service.updateUserWithoutValidation(this.user, () => {
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
